import { render } from "./indexComissionComponent.vue?vue&type=template&id=39c10b88&scoped=true"
import script from "./indexComissionComponent.vue?vue&type=script&lang=js"
export * from "./indexComissionComponent.vue?vue&type=script&lang=js"

import "./indexComissionComponent.vue?vue&type=style&index=0&id=39c10b88&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39c10b88"]])

export default __exports__